// @flow
import { createSlice } from '@reduxjs/toolkit'

const orderItems = (resources: any, packet: any) => {
  if (!packet || !packet.ordering) return resources

  const { ordering } = packet

  const resourcesWithOrder = resources.map((resource) => {
    const key = resource.type === 'form' ? 'form' : 'document'

    return {
      ...resource,
      order: ordering?.find((o) => o[key] === resource.id)?.order || 0,
    }
  })

  return resourcesWithOrder.sort((a, b) => a.order - b.order)
}

const packetSlice: typeof createSlice = createSlice({
  name: 'packet',
  initialState: {
    completePage: null,
  },
  reducers: {
    clearState: () => ({
      completePage: null,
    }),
    setPacket: (state, action) => {
      const packet = action.payload || {}
      const itemDetails = packet.item_details || {}
      const formDetails = itemDetails.forms || []
      const documentDetails = itemDetails.documents || []
      const items = [...documentDetails, ...formDetails]
      packet.items = orderItems(items, packet)
      return { ...state, ...packet }
    },
    setCompletePage: (state, action) => {
      state.completePage = action.payload ?? null
    },
    setName: (state, action) => {
      state.name = action.payload
    },
    setErrors: (state, action) => {
      if (!action.payload) {
        state.errors = null
      } else {
        state.errors = { ...(state.errors || {}), ...action.payload }
      }
    },
    setNotificationUsers: (state, action) => {
      state.notification_users = action.payload
    },
    setResourceSettings: (state, action) => {
      state.resourceSettings = action.payload
    },
    setIsDirty: (state, action) => {
      state.isDirty = action.payload
    },
    addItem: (state, action) => {
      const item = action.payload
      const items = state.items || []
      state.items = [...items, item]
    },

    remove: (state, action) => {
      const itemId = action.payload
      const items = state.items || []
      state.items = items.filter((item) => item.id !== itemId)
    },
    addAll: (state, action) => {
      state.items = action.payload
    },
    removeAll: (state) => {
      state.items = []
    },
    move: (state, action) => {
      const { sourceIndex, destinationIndex } = action.payload
      const items = state.items || []
      const targetItem = items[sourceIndex]
      const newItems = Array.from(items)
      newItems.splice(sourceIndex, 1)
      newItems.splice(destinationIndex || 0, 0, targetItem)
      state.items = newItems
    },
  },
})

export const {
  addAll,
  addItem,
  clearState,
  move,
  remove,
  removeAll,
  setErrors,
  setName,
  setNotificationUsers,
  setPacket,
  setCompletePage,
  setResourceSettings,
  setIsDirty,
} = packetSlice.actions
export default packetSlice.reducer
